import { useState, Component, Suspense } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import Sidebar from './Sidebar'
import Header from './Header'
import JarvisButton from './JarvisButton'
import { useAuthStore } from '../store'

function PageLoader() {
  return (
    <div className="flex items-center justify-center h-full min-h-[300px]">
      <div className="w-6 h-6 border-2 border-[#6c63ff] border-t-transparent rounded-full animate-spin" />
    </div>
  )
}

class PageErrorBoundary extends Component {
  constructor(props) { super(props); this.state = { error: null } }
  static getDerivedStateFromError(e) { return { error: e } }
  componentDidUpdate(prevProps) {
    // Reset quando a rota muda (navegação)
    if (prevProps.routeKey !== this.props.routeKey && this.state.error) {
      this.setState({ error: null })
    }
  }
  render() {
    if (this.state.error) {
      return (
        <div className="flex flex-col items-center justify-center h-full min-h-[300px] gap-4 text-center px-6">
          <div className="text-3xl">⚠️</div>
          <p className="text-sm text-[#e8e8f0] font-medium">Erro ao carregar esta página</p>
          <p className="text-xs text-[#6b6b80] max-w-xs">{this.state.error?.message || 'Erro desconhecido'}</p>
          <button
            onClick={() => this.setState({ error: null })}
            className="px-4 py-2 rounded-lg bg-[#6c63ff] text-white text-xs hover:bg-[#5a52d5] transition-colors"
          >
            Tentar novamente
          </button>
        </div>
      )
    }
    return this.props.children
  }
}

export default function Layout() {
  const { user } = useAuthStore()
  const { pathname } = useLocation()
  const isSeller = user?.role === 'seller'
  const isSellerMode = pathname === '/seller'
  const [sidebarOpen, setSidebarOpen] = useState(false)

  // Modo Vendedor: fullscreen sem sidebar/header
  if (isSellerMode) {
    return (
      <div className="min-h-screen bg-[#0a0a0f] flex justify-center">
        <div className="w-full max-w-md flex flex-col min-h-screen">
          <Outlet />
        </div>
      </div>
    )
  }

  return (
    <div className="flex min-h-screen bg-[#0a0a0f]">
      {!isSeller && (
        <Sidebar
          isOpen={sidebarOpen}
          onClose={() => setSidebarOpen(false)}
        />
      )}
      <div className="flex-1 flex flex-col min-w-0">
        <Header onMenuToggle={() => setSidebarOpen(v => !v)} showMenuButton={!isSeller} />
        <main className="flex-1 p-4 md:p-6 overflow-auto animate-fade-in">
          <Suspense fallback={<PageLoader />}>
            <PageErrorBoundary routeKey={pathname}>
              <Outlet />
            </PageErrorBoundary>
          </Suspense>
        </main>
      </div>
      {!isSeller && <JarvisButton />}
    </div>
  )
}
